module.exports = __webpack_public_path__ + "media/components/Containers/BlockBookings/helpers/profilePic-068ed36dd098aa6b65e5b30f403a69df.png";